import React, { Component } from 'react'
import './index.css'
import { BsyUtils } from "../../utils/Utils";
import LoginAccountInput from "../../Login/LoginAccountInput";
import BsyIconBtn from "../BsyIconBtn";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyAlert from "../BsyAlert";
import BsyDialog from '../BsyDialog';
import BsyDeptJobtitleSelectPane from '../BsyDeptJobtitleSelectPane';

class AlertListCustom extends Component {
    static defaultProps = {
        width: 700,
        pos: "right",
        hasHeader: false,
        hasFooter: false,
    }
    constructor(props) {
        super(props);
        this.state = {
            width: props.width,
            pos: props.pos,
            hasHeader: props.hasHeader,
            hasFooter: props.hasFooter,
        }
    }

    editPane = () =>{
        return this.props.createContent ? this.props.createContent(this) : "";
    }

    closeAlert = () =>{
        this.props.onRemoveRoot();
    }

    render() {
        const { width, hasHeader, hasFooter } = this.state
        return (
            <div className={"content " + window.mode} style={{width: width}}>
                {hasHeader && <div className="alertHeader">
                    
                </div>}
                <div className="editContent" style={{padding: "0"}}>
                    {this.editPane()}
                </div>
                {hasFooter && <div className="alertFooter">
                    {
                        <BsyIconBtn
                            text={React.language('save')}
                            click={this.onSave}
                            iconName=""
                            type="blue"
                            mode={window.mode}
                        />
                    }
                </div>}
            </div>
        )
    }
}

export default AlertListCustom